// services
import forms from "./services/forms";
import notifications from "./services/notifications";
import tokens from "./services/tokens";
import workflow from "./services/workflow";
import cursors from "./services/cursors";
import tenants from "./services/tenants";
import roles from "./services/roles";
import media from "./services/media";
import entity from "./services/entity";
import businessLogic from "./services/businessLogic";
import definitions from "./services/definitions";
import view from "./services/view";

export default {
	forms,
	notifications,
	tokens,
	workflow,
	cursors,
	tenants,
	roles,
	media,
	entity,
	businessLogic,
	definitions,
	view,
};
